import _extends from "@babel/runtime/helpers/extends";
import Button from '@atlaskit/button/standard-button';
import { LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { pluralize } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { ANALYTICS_OBJECT_TYPE_APP_REQUESTS, ANALYTICS_SUBJECT_ID_APP_REQUEST_COUNT } from '../../../../../analytics/Events';
import AppRequestCommentsModal from './AppRequestCommentsModal';
export default function AppRequestCount(props) {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const [isModalOpen, setModalOpenFlag] = useState(false);
  const {
    showManageAppRequestAlternativeLayout
  } = useFeatureFlags();
  const onRequestCountClick = () => {
    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_APP_REQUEST_COUNT,
      objectType: ANALYTICS_OBJECT_TYPE_APP_REQUESTS,
      objectId: props.appKey
    });
    setModalOpenFlag(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onRequestCountClick,
    appearance: "link"
  }, showManageAppRequestAlternativeLayout ? props.requestCount : pluralize('request', props.requestCount, true)), isModalOpen && /*#__PURE__*/React.createElement(AppRequestCommentsModal, _extends({}, props, {
    onClose: () => setModalOpenFlag(false)
  })));
}